"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationsContract = void 0;
const core_1 = require("@ts-rest/core");
const c = (0, core_1.initContract)();
exports.ConversationsContract = c.router({}, { pathPrefix: '/conversations' });
// import { initContract } from '@ts-rest/core';
// import { ErrorResponseSchema } from '../../../shared/common.schema';
// import {
// 	ConversationByIdRequestSchema,
// 	CreateConversationRequestSchema,
// 	GetConversationsRequestSchema,
// 	GetMessagesRequestSchema,
// 	MarkMessagesReadRequestSchema,
// 	SearchConversationsRequestSchema,
// 	SendMessageRequestSchema,
// 	UpdateConversationRequestSchema,
// } from './conversations.request';
// import {
// 	CreateConversationResponseSchema,
// 	GetConversationByIdResponseSchema,
// 	GetConversationsResponseSchema,
// 	GetMessagesResponseSchema,
// 	GetUnreadCountResponseSchema,
// 	MarkMessagesReadResponseSchema,
// 	SearchConversationsResponseSchema,
// 	SendMessageResponseSchema,
// 	UpdateConversationResponseSchema,
// } from './conversations.response';
// const c = initContract();
// export const CandidateConversationsContract = c.router(
// 	{
// 		create: {
// 			body:      CreateConversationRequestSchema,
// 			method:    'POST',
// 			path:      '/',
// 			responses: {
// 				201: CreateConversationResponseSchema,
// 				400: ErrorResponseSchema,
// 				401: ErrorResponseSchema,
// 				422: ErrorResponseSchema,
// 			},
// 			strictStatusCodes: true,
// 			summary:           'Create new conversation',
// 		},
// 		getDetail: {
// 			method:     'GET',
// 			path:       '/:conversationId',
// 			pathParams: ConversationByIdRequestSchema,
// 			responses:  {
// 				200: GetConversationByIdResponseSchema,
// 				400: ErrorResponseSchema,
// 				401: ErrorResponseSchema,
// 				404: ErrorResponseSchema,
// 			},
// 			summary: 'Get conversation by ID',
// 		},
// 		list: {
// 			method:    'GET',
// 			path:      '/',
// 			query:     GetConversationsRequestSchema,
// 			responses: {
// 				200: GetConversationsResponseSchema,
// 				400: ErrorResponseSchema,
// 				401: ErrorResponseSchema,
// 			},
// 			summary: 'Get all conversations for candidate',
// 		},
// 		// Messages routes
// 		messages: c.router({
// 			// Get messages for a conversation
// 			getAll: {
// 				method:     'GET',
// 				path:       '/:conversationId/messages',
// 				pathParams: ConversationByIdRequestSchema,
// 				query:      GetMessagesRequestSchema,
// 				responses:  {
// 					200: GetMessagesResponseSchema,
// 					400: ErrorResponseSchema,
// 					401: ErrorResponseSchema,
// 					404: ErrorResponseSchema,
// 				},
// 				summary: 'Get messages for conversation',
// 			},
// 			// Mark messages as read
// 			markRead: {
// 				body:       MarkMessagesReadRequestSchema,
// 				method:     'POST',
// 				path:       '/:conversationId/messages/mark-read',
// 				pathParams: ConversationByIdRequestSchema,
// 				responses:  {
// 					200: MarkMessagesReadResponseSchema,
// 					400: ErrorResponseSchema,
// 					401: ErrorResponseSchema,
// 					404: ErrorResponseSchema,
// 				},
// 				summary: 'Mark messages as read',
// 			},
// 			// Send new message
// 			send: {
// 				body:       SendMessageRequestSchema,
// 				method:     'POST',
// 				path:       '/:conversationId/messages',
// 				pathParams: ConversationByIdRequestSchema,
// 				responses:  {
// 					201: SendMessageResponseSchema,
// 					400: ErrorResponseSchema,
// 					401: ErrorResponseSchema,
// 					404: ErrorResponseSchema,
// 					422: ErrorResponseSchema,
// 				},
// 				strictStatusCodes: true,
// 				summary:           'Send message in conversation',
// 			},
// 		}),
// 		// Search conversations
// 		search: {
// 			method:    'GET',
// 			path:      '/search',
// 			query:     SearchConversationsRequestSchema,
// 			responses: {
// 				200: SearchConversationsResponseSchema,
// 				400: ErrorResponseSchema,
// 				401: ErrorResponseSchema,
// 			},
// 			summary: 'Search conversations',
// 		},
// 		// Get unread count
// 		unreadCount: {
// 			method:    'GET',
// 			path:      '/unread-count',
// 			responses: {
// 				200: GetUnreadCountResponseSchema,
// 				401: ErrorResponseSchema,
// 			},
// 			summary: 'Get total unread messages count',
// 		},
// 		// Update conversation
// 		update: {
// 			body:       UpdateConversationRequestSchema,
// 			method:     'PATCH',
// 			path:       '/:conversationId',
// 			pathParams: ConversationByIdRequestSchema,
// 			responses:  {
// 				200: UpdateConversationResponseSchema,
// 				400: ErrorResponseSchema,
// 				401: ErrorResponseSchema,
// 				404: ErrorResponseSchema,
// 				422: ErrorResponseSchema,
// 			},
// 			summary: 'Update conversation status or subject',
// 		},
// 	},
// 	{ pathPrefix: '/conversations' },
// );
